// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.AttributePanel__numericInput___cbtnK {
    width: 22rem;
}

/* stylelint-disable-next-line selector-class-pattern -- класс Consta */
.TextField-Label {
    white-space: nowrap;
}
`, "",{"version":3,"sources":["webpack://./../GM.Frontend.Library/src/components/AttributePanel/AttributePanel.css"],"names":[],"mappings":"AAAA;IACI,YAAY;AAChB;;AAEA,uEAAuE;AACvE;IACI,mBAAmB;AACvB","sourcesContent":[".numericInput {\n    width: 22rem;\n}\n\n/* stylelint-disable-next-line selector-class-pattern -- класс Consta */\n:global(.TextField-Label) {\n    white-space: nowrap;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"numericInput": `AttributePanel__numericInput___cbtnK`
};
export default ___CSS_LOADER_EXPORT___;
